import { PagesEnum } from './enums';

export const AppRoutes = {
  home: '/',
  school: '/entrepreneur-school',
  courses: '/courses',
  freeConsultation: '/free-consultation',
  search: '/search',
  orgInfo: '/org-info',
};

export const RequiredErrorMessage = 'Обязательное поле';

export const InvalidEmailErrorMessage = 'Неверный формат';

export const InvalidPhoneErrorMessage = 'Неверный формат';

export const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const deviceBreakpoints = {
  desktop: 1680,
  laptop: 1280,
  tablet: 1024,
  mobile: 768,
};

export const ROOT_ID = 'root';

export const APP_ID = 'application';

export const sectionIds: Record<PagesEnum, Record<string, string>> = {
  [PagesEnum.Home]: {
    banner: 'home-banner',
    courses: 'home-business-courses',
    tools: 'home-tools',
    consultation: 'home-free-consultation',
    comfortability: 'home-comfortability',
    weProvideConditions: 'home-we-provide-conditions',
    experts: 'home-experts',
    yourFuture: 'home-your-future',
    team: 'home-team',
    carousel: 'home-carousel',
  },
  [PagesEnum.School]: {
    hero: 'school-hero',
    tools: 'school-tools',
    consultation: 'school-free-consultation',
    coursePackets: 'school-course-packets',
    ourExperts: 'school-our-experts',
    ownBusiness: 'school-own-business',
    businessPhases: 'school-business-phases',
    comfortability: 'school-comfortability',
    weProvideConditions: 'school-we-provide-conditions',
  },
  [PagesEnum.Courses]: {
    ourAuditorium: 'courses-our-auditorium',
    tools: 'courses-tools',
    coursePackets: 'courses-course-packets',
    consultation: 'courses-free-consultation',
  },
  [PagesEnum.CourseDetails]: {
    courseHero: 'course-details-hero',
    benefits: 'course-details-benefits',
    courseAuditorium: 'course-details-course-auditorium',
    upcomingSteps: 'course-details-upcoming-steps',
    weProvideConditions: 'course-details-we-provide-conditions',
    enrollCourse: 'course-details-enroll-course',
  },
  [PagesEnum.FreeConsultation]: {
    individualCasting: 'free-consultation-individual-casting',
    idealMatch: 'free-consultation-ideal-match',
    parsing: 'free-consultation-parsing',
    inResult: 'free-consultation-in-result',
    universalExpert: 'free-consultation-universal-expert',
    consultation: 'free-consultation-section',
  },
};

export const pageTitles: Record<PagesEnum, string> = {
  [PagesEnum.Home]: 'главная',
  [PagesEnum.School]: 'школа предпринимателя',
  [PagesEnum.Courses]: 'курсы',
  [PagesEnum.CourseDetails]: 'курсы подробнее',
  [PagesEnum.FreeConsultation]: 'бесплатная консультация',
};

export const searchKeyMinLength = 3;
